import { selector } from "recoil";
export const getProducts = selector({
    key: "getProducts",
    get: async () => {
        const response = await fetch("https://api.undiesy.com/products");
        const { data: products } = await response.json();
        return products;
    }
});
